type Props = {
  children: React.ReactNode;
  title?: React.ReactNode | string | string[];
  description?: string;
  personalLink?: string;
};

export const FormWrapper = ({
  children,
  title,
  description,
  personalLink,
}: Props) => {
  return (
    <div className="md:mt mt-[60px] flex flex-col justify-between relative items-center">
      {personalLink && (
        <p className="text-center text-gray-text md:text-[16px] text-xs md:mb-3 mb-2">
          Your personal link is{' '}
          <span className="text-black">player3.io/{personalLink}!</span>
        </p>
      )}
      <h1 role='heading' className="md:text-[54px]! text-2xl! font-semibold! md:pb-3 pb-2 text-center max-w-[600px] w-full leading-tight">
        {Array.isArray(title)
          ? title.map((line, i) => <div key={i}>{line}</div>)
          : title}
      </h1>
      <p className="text-gray-text md:text-xl text-sm md:font-normal font-light text-center md:px-0 px-8 md:mb-24 mb-10 ml-2.5">
        {description}
      </p>
      {children}
    </div>
  );
};
